/* BLIS-TOP – Hebrew search fallback.
   Shopify predictive search does not support Hebrew (search/suggest returns 417 "Unsupported buyer locale"),
   and /search sometimes prints a loading error instead of results. This script searches a lightweight product index
   (templates/collection.searchindex.liquid) in the browser instead, for both the predictive dropdown and /search. */
(function () {
  var ERR_RE = /אירעה בעיה בטעינת תוצאות החיפוש שלך\.\s*יש לרענן את הדף או לנסות שוב מאוחר יותר\./g;
  var MIN_CHARS = 2;
  var CACHE_KEY = 'bt-search-index-v1';
  var CACHE_MS = 30 * 60 * 1000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var indexPromise = null;

  var FINALS = { 'ך': 'כ', 'ם': 'מ', 'ן': 'נ', 'ף': 'פ', 'ץ': 'צ' };
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[֑-ׇ]/g, '')
      .replace(/[ךםןףץ]/g, function (c) { return FINALS[c]; })
      .replace(/[׳'"״`\-–—_.,/\\()|+:]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function productUrl(p) { return root + 'products/' + encodeURIComponent(p.h); }

  function prepare(list) {
    list.forEach(function (p) {
      p.p = String(p.p || '').replace(/\s*NIS$/, ' ₪');
      p.c = String(p.c || '').replace(/\s*NIS$/, ' ₪');
      p.nt = norm(p.t);
      p.k = norm([p.t, p.v, p.y, p.g].join(' '));
    });
    return list;
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = (function () {
      try {
        var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
        if (cached && Date.now() - cached.t < CACHE_MS && cached.d && cached.d.length) return Promise.resolve(prepare(cached.d));
      } catch (e) {}
      function page(n) {
        return fetch(root + 'collections/all?view=searchindex&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (t) { return JSON.parse(t); });
      }
      return page(1).then(function (first) {
        var pages = Math.min(first.pages || 1, 20), rest = [];
        for (var n = 2; n <= pages; n++) rest.push(page(n));
        return Promise.all(rest).then(function (more) {
          var all = first.products;
          more.forEach(function (m) { all = all.concat(m.products); });
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: all })); } catch (e) {}
          return prepare(all);
        });
      });
    })();
    indexPromise.catch(function () { indexPromise = null; });
    return indexPromise;
  }

  function search(all, q) {
    var words = norm(q).split(' ').filter(Boolean);
    if (!words.length) return [];
    var out = [];
    all.forEach(function (p) {
      for (var i = 0; i < words.length; i++) if (p.k.indexOf(words[i]) === -1) return;
      var s = 0, padded = ' ' + p.nt;
      if (p.nt.indexOf(words[0]) === 0) s += 4;
      if (words.every(function (w) { return p.nt.indexOf(w) !== -1; })) s += 3;
      if (words.every(function (w) { return padded.indexOf(' ' + w) !== -1; })) s += 2;
      if (p.a) s += 1;
      out.push([s, p]);
    });
    out.sort(function (a, b) { return b[0] - a[0]; });
    return out.map(function (r) { return r[1]; });
  }

  var ARROW = '<svg class="icon icon-arrow" viewBox="0 0 14 10" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/></svg>';

  function predictiveMarkup(q, list) {
    var top = list.slice(0, 6);
    var h = '<div id="predictive-search-results" role="listbox">' +
      '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions">';
    if (top.length) {
      h += '<div class="predictive-search__result-group"><div>' +
        '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">מוצרים</h2>' +
        '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">';
      top.forEach(function (p, i) {
        h += '<li id="predictive-search-option-product-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
          '<a href="' + productUrl(p) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
          (p.i ? '<img class="predictive-search__image" src="' + esc(p.i) + '" alt="' + esc(p.t) + '" width="50" height="50" loading="lazy">' : '') +
          '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
          '<p class="predictive-search__item-heading h5">' + esc(p.t) + '</p>' +
          '<div class="price' + (p.c ? ' price--on-sale' : '') + '"><div class="price__container">' +
          '<div class="price__regular"><span class="price-item price-item--regular">' + esc(p.p) + '</span></div>' +
          '<div class="price__sale"><span><s class="price-item price-item--regular">' + esc(p.c) + '</s></span> <span class="price-item price-item--sale price-item--last">' + esc(p.p) + '</span></div>' +
          '</div></div></div></a></li>';
      });
      h += '</ul></div></div>';
    }
    h += '</div>' +
      '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">' +
      '<button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false">' +
      '<span data-predictive-search-search-for-text>' + (top.length ? 'לכל התוצאות עבור' : 'חיפוש') + ' "' + esc(q) + '"</span>' + ARROW + '</button></div>' +
      '<span class="hidden" data-predictive-search-live-region-count-value>' + list.length + ' תוצאות</span>' +
      '<span class="hidden" data-total-results="' + list.length + '"></span></div>';
    return h;
  }

  function patchPredictive() {
    var PS = customElements.get('predictive-search');
    if (!PS || PS.prototype.__btFallback) return;
    var original = PS.prototype.getSearchResults;
    PS.prototype.__btFallback = true;
    PS.prototype.getSearchResults = function (term) {
      var self = this;
      if (term.length < MIN_CHARS) { self.close(); return; }
      self.setLiveRegionLoadingState();
      loadIndex().then(function (all) {
        if (self.getQuery() !== term) return;
        self.renderSearchResults(predictiveMarkup(term, search(all, term)));
      }).catch(function () { original.call(self, term); });
    };
  }

  function card(p) {
    var url = productUrl(p), title = esc(p.t);
    return '<li class="grid__item"><div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper--uniform">' +
      '<div class="card card--standard card--media" style="--ratio-percent: 100%;">' +
      '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;"><div class="card__media"><div class="media media--transparent media--hover-effect">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + title + '" class="motion-reduce" loading="lazy" width="533" height="533">' : '') +
      '</div></div><div class="card__content"><div class="card__information"><h3 class="card__heading">' +
      '<a href="' + url + '" class="full-unstyled-link" tabindex="-1" aria-hidden="true"><bdi>' + title + '</bdi></a></h3></div></div></div>' +
      '<div class="card__content"><div class="card__information"><h3 class="card__heading h5">' +
      '<a href="' + url + '" class="full-unstyled-link"><bdi>' + title + '</bdi></a></h3>' +
      '<div class="card-information"><div class="price' + (p.c ? ' price--on-sale' : '') + (p.a ? '' : ' price--sold-out') + '"><div class="price__container">' +
      '<div class="price__regular"><span class="price-item price-item--regular">' + esc(p.p) + '</span></div>' +
      '<div class="price__sale"><span><s class="price-item price-item--regular">' + esc(p.c) + '</s></span> <span class="price-item price-item--sale price-item--last">' + esc(p.p) + '</span></div>' +
      '</div></div>' + (p.a ? '' : '<p class="caption-large light">אזל מהמלאי</p>') +
      '</div></div></div></div></div></li>';
  }

  function fixSearchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var anchor = document.querySelector('#ProductGridContainer') || document.querySelector('main-search'); var section = (anchor && anchor.closest('.shopify-section')) || document.querySelector('main');
    if (!section || !ERR_RE.test(section.innerHTML)) return;
    ERR_RE.lastIndex = 0;
    // remove the error text Shopify printed in place of the search results
    section.querySelectorAll('[class]').forEach(function (el) {
      var c = el.getAttribute('class');
      if (c.indexOf('אירעה') !== -1) el.setAttribute('class', c.replace(ERR_RE, ' ').replace(/\s+/g, ' ').trim());
    });
    var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT), nodes = [];
    while (walker.nextNode()) if (walker.currentNode.nodeValue.indexOf('אירעה') !== -1) nodes.push(walker.currentNode);
    nodes.forEach(function (n) { n.nodeValue = n.nodeValue.replace(ERR_RE, ''); });

    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    var type = new URLSearchParams(location.search).get('type');
    if (type && type.indexOf('product') === -1) return;

    var cardCss = document.querySelector('link[href*="/component-card.css"]');
    if (cardCss && !document.querySelector('link[href*="component-product-card-uniform.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = cardCss.href.replace(/component-card\.css[^"]*$/, 'component-product-card-uniform.css');
      document.head.appendChild(l);
    }
    var box = section.querySelector('#ProductGridContainer');
    if (!box) {
      box = document.createElement('div');
      box.id = 'ProductGridContainer';
      (section.querySelector('.template-search') || section).appendChild(box);
    }
    box.innerHTML = '<p class="center caption-large" style="margin:2rem 0">בטעינה…</p>';
    loadIndex().then(function (all) {
      var list = search(all, q);
      if (!list.length) {
        box.innerHTML = '<div class="page-width"><p class="center" style="margin:2rem 0 4rem">לא נמצאו מוצרים עבור "' + esc(q) + '". נסו מילה אחרת.</p></div>';
        return;
      }
      box.innerHTML = '<div class="collection page-width">' +
        '<p class="center caption-large light" style="margin:0 0 2.5rem">' + list.length + ' מוצרים עבור "' + esc(q) + '"</p>' +
        '<ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop">' +
        list.slice(0, 120).map(card).join('') + '</ul></div>';
    }).catch(function () {
      box.innerHTML = '<div class="page-width"><p class="center" style="margin:2rem 0 4rem">לא הצלחנו לטעון תוצאות. נסו לרענן את הדף.</p></div>';
    });
  }

  if (window.customElements) customElements.whenDefined('predictive-search').then(patchPredictive);
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="search"], input[name="q"]')) loadIndex().catch(function () {});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixSearchPage);
  else fixSearchPage();
})();/* BLIS-TOP – "price on request" products.
   Any product whose price is 0 cannot be bought online: the product page shows a
   WhatsApp quote button instead of add-to-cart, product cards show "לקבלת הצעת מחיר"
   instead of ₪0, and a 0-priced item that somehow reaches the cart is removed. */
(function () {
  var WA_NUMBER = '972547567095';
  var LABEL = 'לקבלת הצעת מחיר';
  var BTN_TEXT = 'לקבלת הצעת מחיר בוואטסאפ';
  var ZERO_RE = /^[^\d]*0(?:[.,]00)?[^\d]*$/;

  function waLink(title) {
    var msg = 'שלום, אשמח לקבל הצעת מחיר עבור: ' + title + '\n' + location.origin + location.pathname;
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function cleanTitle(t) {
    return (t || '').replace(/לקבלת הצעת מחיר ניתן ליצור קשר\.?/g, '').replace(/\s+/g, ' ').trim();
  }

  function productPage() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!meta || !meta.variants || !meta.variants.length) return;
    var allZero = meta.variants.every(function (v) { return Number(v.price) === 0; });
    if (!allZero) return;
    document.querySelectorAll('product-form .product-form__buttons').forEach(function (box) {
      if (box.querySelector('.bt-quote-btn')) return;
      box.querySelectorAll('button[name="add"], .shopify-payment-button').forEach(function (el) { el.style.display = 'none'; });
      var h1 = document.querySelector('.product__title h1') || document.querySelector('h1');
      var a = document.createElement('a');
      a.className = 'bt-quote-btn button button--full-width button--primary';
      a.href = waLink(cleanTitle(h1 ? h1.textContent : document.title));
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = BTN_TEXT;
      box.appendChild(a);
    });
    document.querySelectorAll('[id^="price-"] .price').forEach(function (p) {
      if (p.dataset.btQuote) return;
      p.dataset.btQuote = '1';
      p.innerHTML = '<span class="price-item price-item--regular">' + LABEL + '</span>';
    });
    document.querySelectorAll('.product-form__quantity, [id^="Quantity-Form-"], .price-per-item__container, .product__tax').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function cards(root) {
    (root || document).querySelectorAll('.price').forEach(function (p) {
      if (p.dataset.btQuote || p.closest('[id^="price-template"]')) return;
      var reg = p.querySelector('.price__regular .price-item--regular') || p.querySelector('.price-item--regular');
      if (!reg || !ZERO_RE.test(reg.textContent.trim())) return;
      var sale = p.querySelector('.price__sale .price-item--sale');
      if (sale && !ZERO_RE.test(sale.textContent.trim())) return;
      p.dataset.btQuote = '1';
      p.innerHTML = '<span class="price-item price-item--regular" style="font-size:0.9em">' + LABEL + '</span>';
      var card = p.closest('.card-wrapper, .product-card-wrapper, li');
      if (card) {
        card.querySelectorAll('.quick-add, product-form, button[name="add"]').forEach(function (el) { el.style.display = 'none'; });
      }
    });
  }

  function cartGuard() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var zero = {};
      var any = false;
      cart.items.forEach(function (it) {
        if (it.price === 0) { zero[it.key] = 0; any = true; }
      });
      if (!any) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: zero })
      }).then(function () {
        if (/^\/cart/.test(location.pathname)) location.reload();
      });
    }).catch(function () {});
  }

  function run() {
    productPage();
    cards();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  cartGuard();
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart"]')) setTimeout(cartGuard, 1500);
  }, true);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* BLIS-TOP – keep Dawn search working: header search pill has no reset button, and the "search for" button can hold an older term */
(function () {
  function patch() {
    var PS = customElements.get('predictive-search');
    if (!PS || PS.prototype.__btSafe) return;
    PS.prototype.__btSafe = true;
    var SF = Object.getPrototypeOf(PS.prototype);
    var origToggle = SF.toggleResetButton;
    if (origToggle) SF.toggleResetButton = function () { if (!this.resetButton) return; return origToggle.apply(this, arguments); };
    var origUpdate = PS.prototype.updateSearchForTerm;
    if (origUpdate) PS.prototype.updateSearchForTerm = function () { try { return origUpdate.apply(this, arguments); } catch (e) {} };
  }
  if (window.customElements) customElements.whenDefined('predictive-search').then(patch);
})();


/* BLIS-TOP – instant search: search the full catalog (not only the first 200 products), match each word separately (e.g. "נרתיק לאקדח") with Hebrew prefixes (ל/ב/ה/ו/מ/ש/כ), and never cover the theme results with an empty "no results" box */
(function () {
  var PREFIX = 'ולבהמשכ';
  function variants(w) {
    var v = [w];
    if (w.length >= 4 && PREFIX.indexOf(w[0]) !== -1) v.push(w.slice(1));
    if (w.length >= 5 && PREFIX.indexOf(w[0]) !== -1 && PREFIX.indexOf(w[1]) !== -1) v.push(w.slice(2));
    return v;
  }
  function wordScore(p, w) {
    var title = (p.title || '').toLowerCase(), other = ((p.type || '') + ' ' + (p.vendor || '')).toLowerCase(), desc = (p.description || '').toLowerCase(), best = 9;
    variants(w).forEach(function (v) {
      if (title.split(/\s+/).some(function (t) { return t.indexOf(v) === 0; })) best = Math.min(best, 0);
      else if (title.indexOf(v) !== -1) best = Math.min(best, 1);
      else if (other.indexOf(v) !== -1) best = Math.min(best, 2);
      else if (v.length >= 3 && desc.indexOf(v) !== -1) best = Math.min(best, 3);
    });
    return best;
  }
  function fullCatalog() {
    try {
      var cached = JSON.parse(sessionStorage.getItem('bt-search-index-v1') || 'null');
      if (cached && cached.d && cached.d.length) return Promise.resolve(cached.d);
    } catch (e) {}
    function page(n) { return fetch('/collections/all?view=searchindex&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    return page(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= Math.min(first.pages || 1, 20); n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var all = first.products;
        more.forEach(function (m) { all = all.concat(m.products); });
        return all;
      });
    });
  }
  function patch() {
    var IS = customElements.get('blistop-instant-search');
    if (!IS || IS.prototype.__btWords) return;
    IS.prototype.__btWords = true;
    var origRanked = IS.prototype.ranked, origRender = IS.prototype.render;
    IS.prototype.ranked = function (q) {
      var words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length >= 2; });
      if (words.length < 2) {
        var single = origRanked.call(this, q);
        if (single.length || !words.length) return single;
      }
      if (!words.length) return [];
      var ql = q.toLowerCase().trim(), rows = [];
      this.products.forEach(function (p) {
        var hit = 0, s = 0;
        words.forEach(function (w) { var ws = wordScore(p, w); if (ws < 9) { hit++; s += ws; } });
        if (!hit) return;
        if ((p.title || '').toLowerCase().indexOf(ql) !== -1) s -= 5;
        rows.push({ p: p, hit: hit, s: s });
      });
      var max = rows.reduce(function (m, r) { return Math.max(m, r.hit); }, 0);
      return rows.filter(function (r) { return r.hit === max; })
        .sort(function (a, b) { return a.s - b.s || (a.p.title || '').localeCompare(b.p.title || '', 'he'); })
        .map(function (r) { return r.p; });
    };
    IS.prototype.render = function (results) {
      if (!results.length) { this.hide(); return; }
      return origRender.apply(this, arguments);
    };
    var el = document.querySelector('blistop-instant-search');
    if (el && el.cache) el.cache.clear();
    fullCatalog().then(function (list) {
      if (!el || !list || !list.length) return;
      el.products = list.map(function (p) {
        return { title: p.t, url: '/products/' + p.h, price: Math.round(parseFloat(String(p.p).replace(/[^\d.]/g, '')) * 100) || 0, image: p.i, type: p.y, vendor: p.v, description: p.g };
      });
      el.cache.clear();
    }).catch(function () {});
  }
  if (window.customElements) customElements.whenDefined('blistop-instant-search').then(patch);
})();


/* BLIS-TOP – product page: hide option values that don't exist for the options chosen before them (e.g. level 4 for XL plates) instead of showing a dead "לא זמין" choice; if the current pick stops existing, move to the nearest one that does */
(function () {
  var variants = null, busy = false, timer = null;
  function exists(combo) {
    return variants.some(function (v) { return combo.every(function (val, i) { return val === null || v.options[i] === val; }); });
  }
  function apply() {
    var vs = document.querySelector('variant-selects');
    if (!vs || !variants || busy) return;
    var fieldsets = [].slice.call(vs.querySelectorAll('fieldset'));
    if (fieldsets.length < 2) return;
    var sel = fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
    for (var k = 1; k < fieldsets.length; k++) {
      var before = sel.slice(0, k), inputs = [].slice.call(fieldsets[k].querySelectorAll('input[type=radio]'));
      inputs.forEach(function (input) {
        var ok = exists(before.concat([input.value])), label = fieldsets[k].querySelector('label[for="' + input.id + '"]');
        input.hidden = !ok;
        if (label) label.style.display = ok ? '' : 'none';
      });
      var cur = inputs.findIndex(function (i) { return i.checked; });
      if (cur !== -1 && inputs[cur].hidden) {
        var pick = null;
        for (var i = cur; i >= 0 && !pick; i--) if (!inputs[i].hidden) pick = inputs[i];
        for (var j = cur; j < inputs.length && !pick; j++) if (!inputs[j].hidden) pick = inputs[j];
        if (pick) { busy = true; pick.click(); setTimeout(function () { busy = false; schedule(); }, 300); }
        return;
      }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 30); }
  function init() {
    var vs = document.querySelector('variant-selects');
    if (!vs || !vs.dataset.productHandle) return;
    fetch('/products/' + vs.dataset.productHandle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (!p.variants || p.variants.length < 2) return;
      variants = p.variants;
      apply();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* BLIS-TOP – the welcome popup belongs on the home page only */
(function () {
  if (/^\/?$/.test(location.pathname)) return;
  function drop() { var p = document.getElementById('bt-popup'); if (p) p.remove(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', drop); else drop();
})();


/* BLIS-TOP – purchase confidence: Google Pay in the payment line, a sticky add-to-cart bar on mobile product pages, WhatsApp links that name the product, and the trust rows under the cart's checkout button */
(function () {
  // each brand in its own <bdi> so the Hebrew/English order stays right-to-left
  var PAY = 'כרטיס אשראי · <bdi>Bit</bdi> · <bdi>Apple Pay</bdi> · <bdi>Google Pay</bdi>';
  var FREE = 300;
  var ICON = {
    lock: '<rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V7.5a4 4 0 0 1 8 0V11"></path>',
    truck: '<path d="M3.5 6.5h10v10h-10z"></path><path d="M13.5 10h3l4 4v2.5h-2"></path><path d="M16.5 10v4h4"></path><path d="M8 17.5h7.5"></path><circle cx="6.5" cy="17.5" r="1.5"></circle><circle cx="17" cy="17.5" r="1.5"></circle>',
    back: '<path d="M9 14 4 9l5-5"></path><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"></path>',
    star: '<path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z" fill="#f5b301" stroke="none"></path>'
  };
  function svg(name) { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON[name] + '</svg>'; }

  var css = document.createElement('style');
  css.textContent =
    '.bt-sb{position:fixed;left:0;right:0;bottom:0;z-index:45;display:flex;align-items:center;gap:10px;padding:10px 12px calc(10px + env(safe-area-inset-bottom));background:rgb(13,19,23);color:#fff;box-shadow:0 -6px 20px rgba(0,0,0,.25);transform:translateY(110%);transition:transform .25s ease;direction:rtl}' +
    '.bt-sb.is-on{transform:none}' +
    '.bt-sb img{width:44px;height:44px;object-fit:contain;background:#fff;border-radius:6px;flex:none}' +
    '.bt-sb__txt{flex:1;min-width:0;line-height:1.25}' +
    '.bt-sb__t{font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:.9}' +
    '.bt-sb__p{font-size:15px;font-weight:700;color:rgb(239,145,45)}' +
    '.bt-sb button{flex:none;min-height:44px;padding:0 18px;border:0;border-radius:8px;background:rgb(239,145,45);color:rgb(13,19,23);font:600 16px Assistant,sans-serif;cursor:pointer}' +
    '.bt-sb button[disabled]{opacity:.55;cursor:default}' +
    '@media (min-width:750px){.bt-sb{display:none}}' +
    'body.bt-sb-on .floating-actions__button,body.bt-sb-on aside.accessibility-widget,body.bt-sb-on #bt-ship{translate:0 -68px;transition:translate .25s ease}' +
    '.bt-trust{margin-top:16px;display:grid;gap:10px;text-align:right;direction:rtl}' +
    '.bt-trust__row{display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:1.35}' +
    '.bt-trust__row svg{flex:none;margin-top:1px}' +
    '.bt-trust__row small{display:block;opacity:.75;font-size:13px}';
  document.head.appendChild(css);

  function money(n) { return n.toLocaleString('he-IL', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ₪'; }

  function productPage() {
    var pay = document.querySelector('.pdp-decision-support__row--payment .pdp-decision-support__detail');
    if (pay && !/Google Pay/.test(pay.textContent)) pay.innerHTML = PAY;

    var title = (document.querySelector('.product__title') || {}).innerText || document.title;
    var text = 'היי, אשמח לפרטים על: ' + title.trim() + '\n' + location.origin + location.pathname;
    document.querySelectorAll('a[href^="https://wa.me/"]').forEach(function (a) {
      if (a.href.indexOf('?') === -1) a.href = a.href + '?text=' + encodeURIComponent(text);
    });

    var real = document.querySelector('product-form .product-form__submit[name="add"]');
    if (!real) return;
    var img = document.querySelector('.product__media img');
    var bar = document.createElement('div');
    bar.className = 'bt-sb';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<div class="bt-sb__txt"><div class="bt-sb__t"></div><div class="bt-sb__p"></div></div><button type="button" tabindex="-1"></button>';
    bar.querySelector('.bt-sb__t').textContent = title.trim();
    document.body.appendChild(bar);
    var btn = bar.querySelector('button'), priceEl = bar.querySelector('.bt-sb__p');
    function sync() {
      var cur = document.querySelector('product-form .product-form__submit[name="add"]') || real;
      real = cur;
      var label = (cur.querySelector('span') || cur).textContent.trim();
      btn.textContent = label;
      btn.disabled = cur.disabled;
      var box = document.querySelector('[id^="price-"] .price');
      var p = box && (box.querySelector('.price--on-sale .price-item--sale') || box.querySelector('.price__regular .price-item--regular'));
      priceEl.textContent = p ? p.textContent.trim() : '';
      return cur.offsetParent !== null && !/^0(\.00)?\s*₪$/.test(priceEl.textContent);
    }
    // show the bar while the real button is off screen (or hidden behind the bottom 80px)
    var queued = false;
    function toggle() {
      queued = false;
      var cur = document.querySelector('product-form .product-form__submit[name="add"]') || real;
      var r = cur.getBoundingClientRect();
      var offScreen = r.bottom < 0 || r.top > window.innerHeight - 80;
      var on = offScreen && window.matchMedia('(max-width: 749px)').matches && sync();
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('bt-sb-on', on);
    }
    function schedule() { if (!queued) { queued = true; setTimeout(toggle, 100); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    setInterval(toggle, 500);
    toggle();
    btn.addEventListener('click', function () { if (!btn.disabled) real.click(); });
  }

  function cartPage() {
    var ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (!ctas || document.querySelector('.bt-trust')) return;
    var box = document.createElement('div');
    box.className = 'bt-trust';
    ctas.insertAdjacentElement('afterend', box);
    function render(sub) {
      var ship = sub >= FREE ? '<strong>ההזמנה שלך כוללת משלוח חינם</strong>' : '<strong>עוד ' + money(FREE - sub) + ' למשלוח חינם</strong><small>או איסוף עצמי מפתח תקווה בתיאום מראש</small>';
      box.innerHTML =
        '<div class="bt-trust__row">' + svg('lock') + '<span><strong>תשלום מאובטח</strong><small>' + PAY + '</small></span></div>' +
        '<div class="bt-trust__row">' + svg('truck') + '<span>' + ship + '</span></div>' +
        '<div class="bt-trust__row">' + svg('back') + '<span><strong>החזרות עד 14 יום</strong><small>בהתאם לחוק הגנת הצרכן</small></span></div>' +
        '<div class="bt-trust__row">' + svg('star') + '<span><strong>דירוג 5.0 בגוגל</strong><small>18 ביקורות של לקוחות, כולן 5 כוכבים</small></span></div>';
    }
    function refresh() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c.total_price / 100); }).catch(function () {}); }
    refresh();
    document.addEventListener('change', function (e) { if (e.target.closest('cart-items')) setTimeout(refresh, 800); });
    document.addEventListener('click', function (e) { if (e.target.closest('cart-remove-button, .quantity__button')) setTimeout(refresh, 800); });
  }

  function init() {
    if (/^\/products\//.test(location.pathname)) productPage();
    if (/^\/cart\/?$/.test(location.pathname)) cartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* BLIS-TOP – installments: from 500 ₪ the order can be split into up to 3 payments at checkout (Tranzila); say so under the price and in the cart */
(function () {
  var MIN = 500, MAX = 3;
  var TEXT = 'אפשר לחלק לעד ' + MAX + ' תשלומים בקופה';
  var css = document.createElement('style');
  css.textContent =
    '.bt-inst{display:flex;align-items:center;gap:6px;margin:6px 0 2px;font-size:14px;font-weight:600;color:rgb(13,19,23);direction:rtl}' +
    '.bt-inst svg{flex:none;color:rgb(239,145,45)}';
  document.head.appendChild(css);
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2.5" y="5.5" width="19" height="13" rx="2"></rect><path d="M2.5 9.5h19M6.5 14.5h4"></path></svg>';

  function num(s) { var n = parseFloat(String(s || '').replace(/[^\d.]/g, '')); return isNaN(n) ? 0 : n; }

  function productPage() {
    var line = document.createElement('div');
    line.className = 'bt-inst';
    line.innerHTML = ICON + '<span>' + TEXT + '</span>';
    function check() {
      var box = document.querySelector('[id^="price-"] .price');
      var p = box && (box.querySelector('.price--on-sale .price-item--sale') || box.querySelector('.price__regular .price-item--regular'));
      var show = p && num(p.textContent) >= MIN;
      var anchor = document.querySelector('.product__info-container .product__tax') || document.querySelector('[id^="price-"]');
      if (show && anchor && line.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', line);
      if (!show && line.parentNode) line.remove();
    }
    check();
    setInterval(check, 800);
  }

  function cartPage() {
    function check() {
      var box = document.querySelector('.bt-trust');
      if (!box) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var row = box.querySelector('.bt-inst-row'), show = c.total_price / 100 >= MIN;
        if (show && !row) {
          var pay = box.querySelector('.bt-trust__row small');
          if (pay) pay.insertAdjacentHTML('afterend', '<small class="bt-inst-row">' + TEXT + '</small>');
        }
        if (!show && row) row.remove();
      }).catch(function () {});
    }
    var queued = false;
    new MutationObserver(function () { if (!queued) { queued = true; setTimeout(function () { queued = false; check(); }, 200); } })
      .observe(document.querySelector('#main-cart-footer') || document.body, { childList: true, subtree: true });
    setTimeout(check, 1200);
  }

  function init() {
    if (/^\/products\//.test(location.pathname)) productPage();
    if (/^\/cart\/?$/.test(location.pathname)) cartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* BLIS-TOP – installments by amount: up to 3 payments from 500 ₪, up to 6 payments from 1,000 ₪ (updates the installments line added above) */
(function () {
  function num(s) { var n = parseFloat(String(s || '').replace(/[^\d.]/g, '')); return isNaN(n) ? 0 : n; }
  function text(amount) { return 'אפשר לחלק לעד ' + (amount >= 1000 ? 6 : 3) + ' תשלומים בקופה'; }
  function fix() {
    var line = document.querySelector('.bt-inst span');
    if (line) {
      var box = document.querySelector('[id^="price-"] .price');
      var p = box && (box.querySelector('.price--on-sale .price-item--sale') || box.querySelector('.price__regular .price-item--regular'));
      var t = text(p ? num(p.textContent) : 0);
      if (line.textContent !== t) line.textContent = t;
    }
    var row = document.querySelector('.bt-inst-row');
    if (row) {
      var t2 = text(num((document.querySelector('.totals__total-value') || {}).textContent));
      if (row.textContent !== t2) row.textContent = t2;
    }
  }
  setInterval(fix, 400);
})();


/* BLIS-TOP – safes ship for a flat 200 ₪ (own shipping profile, never free) with free self-pickup; an order with a safe pays 200 ₪ in total, since the rest of it is always over the free-shipping threshold. Keep every "free shipping" message honest when a safe is involved */
(function () {
  var SAFES = ['protact-tps-1-biometric-pistol-safe', 'protact-quick-access-biometric-pistol-safe',
    'כספת-לאקדח-אישי-עם-מפתח-כפול-שיניים', 'כספת-לאקדח-אישי-טקטיקול-מפתח-או-קוד-דיגיטלי'];
  var FEE = 200;
  var PICKUP = '<strong>או איסוף עצמי בחינם</strong> מפתח תקווה בתיאום מראש';
  var state = { hasSafe: false, other: 0, otherCount: 0 };

  function isSafe(handle) { try { handle = decodeURIComponent(handle); } catch (e) {} return SAFES.indexOf(handle) !== -1; }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? m[1] : ''; }

  var of = window.fetch, pending = null;
  function refresh() {
    if (pending) return pending;
    pending = of.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var s = { hasSafe: false, other: 0, otherCount: 0 };
      c.items.forEach(function (i) {
        if (isSafe(i.handle)) s.hasSafe = true;
        else { s.other += i.final_line_price; s.otherCount += i.quantity; }
      });
      state = s;
      pending = null;
      apply();
      document.querySelectorAll('free-shipping-bar').forEach(function (b) { if (b.refetch) b.refetch(); });
    }).catch(function () { pending = null; });
    return pending;
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    return p;
  };

  // top bar: count only the items that can ship free
  function patchBar() {
    var Bar = customElements.get('free-shipping-bar');
    if (!Bar || Bar.prototype.__btSafe) return;
    Bar.prototype.__btSafe = true;
    var orig = Bar.prototype.render;
    Bar.prototype.render = function (total, count) {
      if (!state.hasSafe) return orig.call(this, total, count);
      if (this.messageEl) this.messageEl.innerHTML = 'משלוח כספת ' + FEE + ' ₪ · <strong>איסוף עצמי בחינם</strong>';
      var t = this.querySelector('.shipping-progress__track');
      if (t) t.remove();
      this.classList.remove('shipping-progress--qualified');
    };
  }
  if (window.customElements) customElements.whenDefined('free-shipping-bar').then(function () { patchBar(); refresh(); });

  function apply() {
    // pop-up after adding to cart
    var toast = document.getElementById('bt-ship');
    var title = toast && toast.querySelector('.bt-ship-title');
    if (title && state.hasSafe) {
      var want = 'משלוח הכספת: <b>' + FEE + ' ₪</b>' + (state.otherCount ? ' לכל ההזמנה' : '');
      if (title.innerHTML !== want) { title.innerHTML = want; toast.classList.remove('bt-free'); }
    }
    // cart trust row
    var rows = document.querySelectorAll('.bt-trust .bt-trust__row');
    if (rows[1] && state.hasSafe) {
      var span = rows[1].querySelector('span');
      var html = '<strong>משלוח הכספת: ' + FEE + ' ₪' + (state.otherCount ? ' לכל ההזמנה' : '') + ' (עקב משקל הכספת)</strong><small>' + PICKUP + '</small>';
      if (span && span.innerHTML !== html) span.innerHTML = html;
    }
  }

  function productPage() {
    if (!isSafe(handleOf(location.pathname))) return;
    var row = document.querySelector('.pdp-decision-support__row--shipping');
    if (!row) return;
    row.classList.remove('pdp-decision-support__row--qualified');
    var strong = row.querySelector('strong'), det = row.querySelector('.pdp-decision-support__detail');
    var s1 = 'משלוח כספת: ' + FEE + ' ₪ (עקב משקל הכספת)';
    if (strong && strong.textContent !== s1) strong.textContent = s1;
    if (det && det.innerHTML !== PICKUP) det.innerHTML = PICKUP;
  }

  function cards() {
    document.querySelectorAll('.card-wrapper, .card').forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a || !isSafe(handleOf(a.getAttribute('href')))) return;
      card.querySelectorAll('.badge, [class*="badge"]').forEach(function (b) { if (/משלוח חינם/.test(b.textContent)) b.remove(); });
    });
  }

  function tick() { productPage(); cards(); apply(); }
  function init() { patchBar(); refresh(); tick(); setInterval(tick, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* BLIS-TOP – the deals popup is off on every page, the home page included (the owner's request) */
(function () {
  function drop() { var p = document.getElementById('bt-popup'); if (p) p.remove(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', drop); else drop();
})();
